// custom-tabs.js
import React from "react"
import { Tabs, Tab, Box } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles((theme) => ({
  tabsContainer: {
    width: "100%",
    backgroundColor: "#f5f5f5",
  },
  tab: {
    textTransform: "none",
    minWidth: 120,
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: theme.spacing(3),
    color: "#6e6e6e", // Non-active tab color - using a medium gray
    padding: theme.spacing(2, 0), // Add padding for top and bottom only
    height: 48, // Adjust height to match screenshot
    "&:hover": {
      color: "#000", // Change text color on hover
      opacity: 1,
    },
    "&.Mui-selected": {
      color: "#000", // Active tab text color
      fontWeight: theme.typography.fontWeightMedium,
    },
    "&:focus": {
      color: "#000",
    },
  },
  indicator: {
    backgroundColor: "#000", // Black underline for active tab
    height: 3, // Thicker underline
  },
  tabs: {
    borderBottom: "1px solid #e0e0e0", // Light gray bottom border for all tabs
  }
}))

const CustomTabs = ({ tabs, activeTab, onTabChange }) => {
  const classes = useStyles()

  return (
    <Box className={classes.tabsContainer}>
      <Tabs
        value={activeTab}
        onChange={onTabChange}
        variant="scrollable"
        scrollButtons="auto"
        classes={{ 
          indicator: classes.indicator,
          flexContainer: classes.tabs
        }}
      >
        {tabs.map((tab, index) => (
          <Tab key={tab.id} label={tab.label} className={classes.tab} />
        ))}
      </Tabs>
    </Box>
  )
}

export default CustomTabs
